import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Payroll = () => {
    const [payrollRecords, setPayrollRecords] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [form, setForm] = useState({ 
        employee_name: '', position: '', pay_period: '', gross_pay: '', sss: '0', pagibig: '0', philhealth: '0' 
    });

    useEffect(() => {
        fetchPayroll();
    }, []);

    const fetchPayroll = async () => {
        try {
            const response = await axios.get('/api/payroll');
            setPayrollRecords(response.data);
        } catch (error) {
            console.error('Error fetching payroll:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (isEditing) {
                await axios.put(`/api/payroll/${editId}`, form);
                alert('✅ Payslip Updated Successfully!');
            } else {
                await axios.post('/api/payroll', form);
                alert('✅ New Payslip Generated!');
            }
            fetchPayroll();
            resetForm();
        } catch (error) {
            alert('❌ Failed to save payslip.');
        }
    };

    const handleEditClick = (record) => {
        setIsEditing(true);
        setEditId(record.id);
        // Load the record data into the form
        setForm({
            employee_name: record.employee_name,
            position: record.position,
            pay_period: record.pay_period,
            gross_pay: record.gross_pay,
            sss: record.sss_deduction,
            pagibig: record.pagibig_deduction,
            philhealth: record.philhealth_deduction
        });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleDelete = async (id, name) => {
        const confirmDelete = window.confirm(`🚨 Are you sure you want to delete the payslip for ${name}?`);
        if (confirmDelete) {
            try {
                await axios.delete(`/api/payroll/${id}`);
                fetchPayroll();
            } catch (error) {
                alert('❌ Failed to delete payslip.');
            }
        }
    };

    const resetForm = () => {
        setIsEditing(false);
        setEditId(null);
        setForm({ employee_name: '', position: '', pay_period: '', gross_pay: '', sss: '0', pagibig: '0', philhealth: '0' });
    };

    return (
        <div className="payroll-container mobile-stack" style={{ backgroundColor: 'white', padding: '25px', borderRadius: '15px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)', animation: 'fadeIn 0.3s' }}>
            <h2 style={{ borderBottom: '2px solid #f1f5f9', paddingBottom: '10px', color: '#1e293b' }}>Staff Payroll Dispenser</h2>
            
            {/* The Calculator Form */}
            <div style={{ backgroundColor: isEditing ? '#fffbeb' : '#f8fafc', padding: '20px', borderRadius: '10px', marginBottom: '25px', border: isEditing ? '1px solid #fde68a' : '1px solid #e2e8f0', transition: 'all 0.3s' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h3 style={{ margin: 0, color: '#334155', fontSize: '16px' }}>
                        {isEditing ? `✏️ Editing Payslip for ${form.employee_name}` : 'Generate New Payslip'}
                    </h3>
                    {isEditing && <button onClick={resetForm} style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', textDecoration: 'underline' }}>Cancel Edit</button>}
                </div>

                <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                    <input type="text" placeholder="Employee Name" required value={form.employee_name} onChange={e => setForm({...form, employee_name: e.target.value})} style={{ padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                    <input type="text" placeholder="Position (e.g., Teacher)" required value={form.position} onChange={e => setForm({...form, position: e.target.value})} style={{ padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                    <input type="text" placeholder="Pay Period (e.g., May 1-15)" required value={form.pay_period} onChange={e => setForm({...form, pay_period: e.target.value})} style={{ padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                    <input type="number" placeholder="Gross Pay (₱)" required value={form.gross_pay} onChange={e => setForm({...form, gross_pay: e.target.value})} style={{ padding: '10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }} />
                    
                    <div style={{ display: 'flex', gap: '10px', gridColumn: '1 / -1', backgroundColor: '#fee2e2', padding: '10px', borderRadius: '6px', border: '1px solid #fca5a5' }}>
                        <div style={{ flex: 1 }}><label style={{ fontSize: '12px', color: '#dc2626', fontWeight: 'bold' }}>SSS (₱)</label><input type="number" required value={form.sss} onChange={e => setForm({...form, sss: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #f87171', marginTop: '5px' }} /></div>
                        <div style={{ flex: 1 }}><label style={{ fontSize: '12px', color: '#dc2626', fontWeight: 'bold' }}>Pag-IBIG (₱)</label><input type="number" required value={form.pagibig} onChange={e => setForm({...form, pagibig: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #f87171', marginTop: '5px' }} /></div>
                        <div style={{ flex: 1 }}><label style={{ fontSize: '12px', color: '#dc2626', fontWeight: 'bold' }}>PhilHealth (₱)</label><input type="number" required value={form.philhealth} onChange={e => setForm({...form, philhealth: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #f87171', marginTop: '5px' }} /></div>
                    </div>
                    
                    <button type="submit" style={{ gridColumn: '1 / -1', backgroundColor: isEditing ? '#f59e0b' : '#10b981', color: 'white', padding: '12px', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' }}>
                        {isEditing ? '💾 Update Payslip' : '⚙️ Generate & Calculate Net Pay'}
                    </button>
                </form>
            </div>

            {/* The Ledger Table */}
            <h3 style={{ color: '#334155', fontSize: '16px', marginBottom: '15px' }}>Historical Ledger</h3>
            <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '14px', minWidth: '700px' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #cbd5e1' }}>
                            <th style={{ padding: '12px', border: '1px solid #e2e8f0' }}>Date</th>
                            <th style={{ padding: '12px', border: '1px solid #e2e8f0' }}>Employee</th>
                            <th style={{ padding: '12px', border: '1px solid #e2e8f0' }}>Period</th>
                            <th style={{ padding: '12px', border: '1px solid #e2e8f0' }}>Gross</th>
                            <th style={{ padding: '12px', border: '1px solid #e2e8f0', color: '#10b981' }}>Net Pay</th>
                            <th style={{ padding: '12px', border: '1px solid #e2e8f0', textAlign: 'center' }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {payrollRecords.length === 0 ? (
                            <tr><td colSpan="6" style={{ padding: '20px', textAlign: 'center', color: '#94a3b8' }}>No payslips generated yet.</td></tr>
                        ) : (
                            payrollRecords.map((record) => (
                                <tr key={record.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                    <td style={{ padding: '12px', color: '#64748b' }}>{new Date(record.created_at).toLocaleDateString()}</td>
                                    <td style={{ padding: '12px', fontWeight: 'bold', color: '#1e293b' }}>{record.employee_name}</td>
                                    <td style={{ padding: '12px' }}>{record.pay_period}</td>
                                    <td style={{ padding: '12px' }}>₱{parseFloat(record.gross_pay).toLocaleString()}</td>
                                    <td style={{ padding: '12px', color: '#10b981', fontWeight: 'bold' }}>₱{parseFloat(record.net_pay).toLocaleString()}</td>
                                    <td style={{ padding: '12px', textAlign: 'center' }}>
                                        <button onClick={() => handleEditClick(record)} style={{ padding: '6px 10px', backgroundColor: '#64748b', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', marginRight: '5px', fontSize: '12px' }}>Edit</button>
                                        <button onClick={() => handleDelete(record.id, record.employee_name)} style={{ padding: '6px 10px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>Delete</button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Payroll;